import { render, staticRenderFns } from "./price-form-page.vue?vue&type=template&id=1b0dcc9f&"
import script from "./price-form-page.vue?vue&type=script&lang=js&"
export * from "./price-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports